import { render, staticRenderFns } from "./test-revoke-auth.vue?vue&type=template&id=4bf8e380&scoped=true&"
import script from "./test-revoke-auth.vue?vue&type=script&lang=js&"
export * from "./test-revoke-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf8e380",
  null
  
)

export default component.exports